module.exports = __webpack_public_path__ + "static/media/magazines-bg.16e9be6b.png";